module.exports = __webpack_public_path__ + "img/metal_as@2x.ea9c508e.png";